<template lang="pug">
  div
    v-dialog(v-model="showPayrollModal" max-width="550px" :persistent="loading === true")

      .dialogHeader
        .dialogHeaderTitle
          | Folha de pagamento

        .dialogHeaderClose
          .dialogCloseButton.mdi.mdi-close(@click="closePayrollModal()")

      .dialogBody
        .dialogBodyContent

          .payrollField.payrollField--no__margin.payrollField--first
            label.csLabel
              span(v-html="'Período'")
            .csFields.csFields--date
              date-picker(v-model="dateRange" :clearable="false" :disabled-date="disableDatesCondition" range valueType="format" format="DD/MM/YYYY" :lang="lang" class="groupUserField--date" :disabled="loading")

          .payrollField
            label.csLabel
              span(v-html="'Opções de Relatório'")
            .csFields.csFields--date
              div
                sos-checkbox(id="resumido" label="Relatório resumido" :checked="isSummaryReport" :disabled="comPonto" @click="onSummaryReportSettingClick" class="sosCheckbox--payroll")

          .payrollField.payrollField--last
            label.csLabel
              span(v-html="'Colunas do Relatório'")
            .csFields.csFields--columns-selection
              .column-group(v-for="group in filteredColumnGroups" :key="group.label")
                h4.column-group-title {{ group.label }}
                div(v-if="group.label === 'Dados do Plantão'")
                  .column-group-option
                    sos-checkbox(id="ponto" label="Incluir registros de ponto?" :checked="comPonto" :disabled="isSummaryReport || loading" @click="onComPontoSettingClick" class="sosCheckbox--payroll")
                  .column-group-separator
                .column-checkbox-group
                  .column-checkbox(v-for="column in group.columns" :key="column.id")
                    sos-checkbox(
                      :id="column.id"
                      :label="column.label"
                      :checked="selectedColumns.includes(column.id)"
                      @click="toggleColumnSelection(column.id)"
                      :disabled="loading || isSummaryReport"
                    )


          .mt-5.text-right
            sos-button(@buttonClick="generate()" color="blue" buttonIcon="mdi-file-document-plus" buttonLabel="Gerar relatório" buttonIconSize="18" size="medium" :loading="loading")

    confirm-dialog(ref="cdConfirmModal" :title="cdParameters.title" :text="cdParameters.text" :buttonPosition="cdParameters.buttonPosition" :width="cdParameters.width" @close="cdMessageResponse")
    subscription-modal(:active="subscriptionModal.active" :titulo="subscriptionModal.title" :text="subscriptionModal.message" @close="closeSubscriptionModal")

</template>

<script>
  import { mapState } from 'vuex'

  import dateTimeLanguage from '@/constants/dateTimeLanguage'
  import { freeVersion } from '@/constants'
  import { apiCheckReportStatus, apiOpenReport } from '@/services/report'

  import { formatDate, isValidDate, parseDate } from '@/mixins/utils.js'

  import SubscriptionModalMixin from '@/mixins/subscription.modal.mixin'
  import confirmDialogMixin from '@/mixins/cd.mixin.js'

  import SosButton from '@/components/SosButton'
  import SosCheckbox from '@/components/SosCheckbox'

  import SubscriptionModal from '@/modals/SubscriptionModal'
  import ConfirmDialog from '@/modals/ConfirmDialog'

  import DatePicker from 'vue2-datepicker'
  import 'vue2-datepicker/index.css'

  import moment from 'moment'
  import 'moment/locale/pt-br'

  moment.locale('pt-BR')

  export default {
    name: 'ExportPayrollModal',

    components: {
      SubscriptionModal,
      'sos-button': SosButton,
      'confirm-dialog': ConfirmDialog,
      'date-picker': DatePicker,
      'sos-checkbox': SosCheckbox,
    },

    mixins: [
      SubscriptionModalMixin,
      confirmDialogMixin,
    ],

    data () {
      return {
        showPayrollModal: false,
        loading: false,
        dateRange: null,
        isSummaryReport: false,
        comPonto: false,
        lang: dateTimeLanguage,
        allAvailableColumnGroups: [
          {
            label: 'Dados do Plantonista',
            columns: [
              { id: 'userName', label: 'Plantonista', defaultChecked: true },
              { id: 'userCRM', label: 'CRM', defaultChecked: true },
              { id: 'userEmail', label: 'E-mail', defaultChecked: true },
              { id: 'userPhone', label: 'Telefone', defaultChecked: true },
              { id: 'userCPF', label: 'CPF', defaultChecked: true },
              { id: 'plantoesComValor', label: 'Plantões (Total)', defaultChecked: true },
              { id: 'chargeHours', label: 'Carga Horária (Total)', defaultChecked: true },
              { id: 'totalValue', label: 'Valor Total', defaultChecked: true },
              { id: 'userAccount', label: 'Dados Bancários', defaultChecked: true },
            ]
          },
          {
            label: 'Dados do Plantão',
            columns: [
              { id: 'data', label: 'Data do Plantão', defaultChecked: true },
              { id: 'startEnd', label: 'Início e Fim do Plantão', defaultChecked: true },
              { id: 'shiftChargeHours', label: 'Carga Horária do Plantão', defaultChecked: true },
              { id: 'turno', label: 'Turno', defaultChecked: true },
              { id: 'local', label: 'Local', defaultChecked: true },
              { id: 'valor', label: 'Valor do Plantão', defaultChecked: true },
              { id: 'observacao', label: 'Observação', defaultChecked: true },
              { id: 'pagto_realizado', label: 'Pagamento Realizado?', defaultChecked: true },
              { id: 'paidPartialValue', label: 'Valor Adiantado', defaultChecked: true },
              { id: 'escala', label: 'Escala', defaultChecked: true },
            ]
          }
        ],
        selectedColumns: [],
        lastSelectedColumns: [],
        summaryReportColumnIds: [
          'userName',
          'plantoesComValor',
          'chargeHours',
          'totalValue',
          'userAccount'
        ],
      }
    },

    computed: {
      ...mapState({
        userSession: state => state.app.userSession,
      }),
      filteredColumnGroups() {
        const isScaleReport = !!this.$route.params.scaleID;

        if (isScaleReport) {
          return this.allAvailableColumnGroups.map(group => {
            if (group.label === 'Dados do Plantão') {
              return {
                ...group,
                columns: group.columns.filter(col => col.id !== 'escala')
              };
            }
            return group;
          });
        }
        return this.allAvailableColumnGroups;
      }
    },

    created() {
      this.initializeSelectedColumns();
    },

    methods: {
      initializeSelectedColumns() {
        this.selectedColumns = this.filteredColumnGroups.flatMap(group =>
          group.columns.filter(col => col.defaultChecked).map(col => col.id)
        );
      },

      disableDatesCondition (date, currentValue) {
        return date < new Date(2016, 0, 1)
      },

      async open (month = 'NO', year = 'NO')
      {
        if (this.loading) return false
        this.showPayrollModal = true

        if (year !== 'NO' && month !== 'NO')
        {
          var firstDay = new Date(year, month, 1)
          var lastDay = new Date(year, month + 1, 0)
          this.dateRange = [formatDate(firstDay), formatDate(lastDay)]
        }
        else
        {
          moment.locale('pt-BR')
          this.dateRange = [
            moment().startOf('month').format('DD/MM/YYYY'),
            moment().endOf('month').format('DD/MM/YYYY'),
          ]
        }
      },

      closePayrollModal ()
      {
        if (!this.loading) this.showPayrollModal = false
      },

      onSummaryReportSettingClick ()
      {
        this.isSummaryReport = !this.isSummaryReport

        if (this.isSummaryReport) {
          this.comPonto = false;
          this.lastSelectedColumns = [...this.selectedColumns];
          this.selectedColumns = [...this.summaryReportColumnIds];
        } else {
          this.selectedColumns = this.lastSelectedColumns.length > 0
            ? [...this.lastSelectedColumns]
            : this.filteredColumnGroups.flatMap(group =>
                group.columns.filter(col => col.defaultChecked).map(col => col.id)
              );
          this.lastSelectedColumns = [];
        }
      },

      onComPontoSettingClick ()
      {
        this.comPonto = !this.comPonto
        if (this.comPonto) this.isSummaryReport = false
      },

      toggleColumnSelection(columnId) {
        if (this.loading || this.isSummaryReport) return;

        const index = this.selectedColumns.indexOf(columnId);
        if (index > -1) {
          this.selectedColumns.splice(index, 1);
        } else {
          this.selectedColumns.push(columnId);
        }
      },

      async generate ()
      {
        if (this.loading) return

        if (freeVersion === false && this.userSession.userCapabilities.folhaPagamento !== true)
        {
          const planName = this.userSession.planName.name
          const talkToOurSupport = `<a href="https://api.whatsapp.com/send?phone=5513992061010&text=Olá, estou no ${planName} e não consigo gerar a folha de pagamento. Preciso de ajuda." target="_blank">suporte</a>`
          const textSupport = `<p>Por favor, verifique a situação do seu plano com o nosso ${talkToOurSupport}.</p>`

          if (this.userSession.planOrigin === 'CUSTOM') {
            this.openSubscriptionModal('Verifique seu plano', `<p>Você está no ${planName} personalizado, mas a folha de pagamento não está liberada.</p>${textSupport}`)
          } else if (this.userSession.planOrigin === 'COUPON') {
            this.openSubscriptionModal('Verifique seu plano', `<p>Você tem um cupom ativo e está no ${planName}, mas a folha de pagamento não está liberada.</p>${textSupport}`)
          } else if (this.userSession.planOrigin === 'VINDI' && this.userSession.vindi.paymentStatus === 'paid') {
            this.openSubscriptionModal('Faça um upgrade', `<p>Você está no ${planName}.</p><p>Para gerar a folha de pagamento, assine o Plano Bronze ou superior.</p><p>Para mais informações, converse o nosso ${talkToOurSupport}.</p>`)
          } else if (this.userSession.planOrigin === 'VINDI' && this.userSession.vindi.paymentStatus !== 'paid') {
            this.openSubscriptionModal('Verifique sua assinatura', `<p>Você é assinante do ${planName}, mas ele não está ativo e a folha de pagamento não está liberada.</p>${textSupport}`)
          } else {
            if (!!this.userSession.vindi === true) {
              this.openSubscriptionModal('Verifique sua assinatura', `<p>Você assinou o ${this.userSession.vindi.planName.name}, mas ele expirou.</p><p>Agora você está no ${planName} e a folha de pagamento não está liberada.</p>${textSupport}`)
            } else {
              this.openSubscriptionModal('Verifique seu plano', `<p>Você está no ${planName} e a folha de pagamento não está liberada.</p>${textSupport}`)
            }
          }
          return false
        }

        const isItValid = Array.isArray(this.dateRange) && this.dateRange.length === 2 && isValidDate(this.dateRange[0]) && isValidDate(this.dateRange[1])
        if (!isItValid) {
          this.showMessage('Atenção!', 'Selecione o período da folha de pagamento')
          return false
        }

        const firstDateObj = parseDate(this.dateRange[0])
        const lastDateObject = parseDate(this.dateRange[1])
        const differenceInDays = Math.floor((lastDateObject - firstDateObj) / (1000 * 60 * 60 * 24))
        if (differenceInDays > 62) {
          this.showMessage('Atenção!', 'Você pode selecionar até dois meses')
          return false
        }

        if (this.isSummaryReport && this.comPonto) {
          this.showMessage('Atenção!', 'Não é possível gerar um relatório resumido com registros de ponto. Escolha apenas uma das opções.')
          return false
        }

        if (!this.isSummaryReport && this.selectedColumns.length === 0) {
            this.showMessage('Atenção!', 'Selecione pelo menos uma coluna para o relatório.')
            return false;
        }

        const { scaleID, groupID } = this.$route.params

        const checkOperationName = scaleID ? 'checkpayroll' : 'checkgrouppayroll'
        const operationName = this.isSummaryReport ? (scaleID ? 'payrollsummary' : 'grouppayrollsummary') : (scaleID ? 'payroll' : 'grouppayroll')
        const hasScale = scaleID ? `${scaleID}/` : ''
        const comPontoParam = this.isSummaryReport ? '' : (this.comPonto ? '/true' : '/false')

        const columnsParam = this.isSummaryReport ? '' : `/${this.selectedColumns.join(',')}`


        this.$emit('setButtonState', true)
        this.loading = true

        try
        {
          const checkEndpoint = `${checkOperationName}/${groupID}/${hasScale}${this.dateRange[0]}/${this.dateRange[1]}`

          let generateUrl;
          if (this.isSummaryReport) {
            generateUrl = `${operationName}/${groupID}/${hasScale}${this.dateRange[0]}/${this.dateRange[1]}`;
          } else {
            generateUrl = `${operationName}/${groupID}/${hasScale}${this.dateRange[0]}/${this.dateRange[1]}${comPontoParam}${columnsParam}`;
          }


          const response = await apiCheckReportStatus(checkEndpoint)

          if (response.code !== 1) {
            this.showMessage(response.title, response.message)
          } else {
            apiOpenReport(generateUrl)
          }
        }
        catch (error)
        {
          this.showMessage('Erro!', 'Não foi possível gerar o relatório. Por favor, atualize a página e tente novamente ou fale com o nosso suporte.')
        }

        this.loading = false
        this.$emit('setButtonState', false)
      },
    },
  }

</script>

<style lang="scss" scoped>

  .groupUserField--date {
    width: 100%;
  }

  .payrollField--last {
    margin-bottom: 20px;
  }

  .csFields--columns-selection {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .column-group {
    margin-bottom: 15px;
  }

  .column-group-title {
    font-size: 1.1em;
    font-weight: bold;
    margin-bottom: 10px;
    color: #333;
    border-bottom: 1px solid #eee;
    padding-bottom: 5px;
  }

  .column-group-option {
    margin-bottom: 10px;
  }

  .column-group-separator {
    border-bottom: 1px dashed #ddd;
    margin: 10px 0;
  }

  .column-checkbox-group {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 10px;
  }

  .sosCheckbox--payroll.sosCheckbox .sosCheckboxLabel {
    padding-left: 7px;
    font-size: 15px;
  }

</style>
